module.exports = "/_next/static/images/down-arrow-3838d40b3378d06f8669b39cbf45efa6.svg";